export default __webpack_public_path__ + "static/media/251036.ef935341.jpg";